// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"uK-z","smallCardRow":"vK-z","largeCardRow":"wK-z","productSearchRow":"xK-z","curatedRow":"yK-z"};